import type { FormType } from '@Types/Blocks/Form';
import type { HeadingType } from '@Types/Shared/Heading';

import Heading from '@Views/Shared/Heading/Heading';

import Decorations from '../../_components/Decorations';
import { getBtnSettingsToCSS } from '../../_lib/btns';
import GForm from './Form';

export default function Form(props: FormType) {
	const {
		title,
		description,
		titleFormat,
		id,
		style,
		containerType,
		wrapperType,
		headingAlign,
		form,
		ctasStyle,
		form_id,
		context = 'form',
		btnSubmitStyle,
		placement,
		sectionDecoration,
	} = props;

	let blockStyle = '';
	if (containerType === 'block') {
		blockStyle =
			'desktop:p-12 tablet:p-5 p-4 bg-minos-form-bg-container-color border-minos-form-container-border-width border-minos-form-container-border-color rounded-minos-form-container';
	}

	let wrapperStyle = '';
	if (wrapperType === 'block') {
		wrapperStyle =
			'tablet:py-6 p-5 desktop:px-32 tablet:px-20 bg-minos-form-bg-wrapper-color border-minos-form-wrapper-border-width rounded-minos-form-wrapper border-minos-form-wrapper-border-color m-auto max-w-3xl';
	} else if (wrapperType === 'center') {
		wrapperStyle = 'm-auto max-w-lg';
	} else if (wrapperType === 'left') {
		wrapperStyle = 'mr-auto max-w-2xl';
	} else {
		wrapperStyle = 'm-auto max-w-4xl';
	}

	const headingProps: HeadingType = {
		title: title,
		description: description,
		titleFormat: titleFormat,
		headingAlign: headingAlign,
		context: context,
		headingFontClassName: {
			title: 'minos-form-heading-title-font-style tablet:minos-form-heading-title-font-style',
			text: {
				p: 'minos-form-heading-description-font-style tablet:minos-form-heading-description-font-style mb-5 tablet:mb-6 last:mb-0',
				a: getBtnSettingsToCSS(ctasStyle, 'a', context),
				btnPrimary: getBtnSettingsToCSS(ctasStyle, 'primary', context),
				btnSecondary: getBtnSettingsToCSS(ctasStyle, 'secondary', context),
				btnTertiary: getBtnSettingsToCSS(ctasStyle, 'tertiary', context),
			},
		},
	};

	let padding = '';
	if (sectionDecoration?.isSectionDecorated && sectionDecoration.type === 'wave') {
		padding = 'pt-8 pb-16 tablet:pt-12 tablet:pb-24 desktop:pb-32';
	} else {
		padding = 'py-3.5 tablet:py-6 desktop:py-12';
	}

	return (
		<section
			style={style}
			data-aos='fade-up'
			id={id}
			className={`minos-grid relative bg-minos-form-bg-color ${padding}`}
		>
			<Decorations
				isSectionDecorated={sectionDecoration?.isSectionDecorated}
				type={sectionDecoration?.type}
				pathClassName={`${sectionDecoration?.type === 'wave' ? 'fill-minos-form-bg-color' : 'fill-minos-decoration-bubble-left'}`}
				pathClassNameRightCircle={`${sectionDecoration?.type === 'bubble' && 'fill-minos-decoration-bubble-right'}`}
				placement={placement}
			>
				<div className={`relative z-[11] col-start-2 col-end-14 ${blockStyle}`}>
					<Heading {...headingProps} />
					<div className={`minos-form-content-font-style ${wrapperStyle}`}>
						<GForm form_id={form_id} form={form} submitBtn={btnSubmitStyle ?? undefined} />
					</div>
				</div>
			</Decorations>
		</section>
	);
}
